import type { AnalyticsEventParams } from 'shared/library/analytics';

export type EvidensiaClinicAction = 'phone' | 'view_clinic';

export function getEvidensiaWidgetAnalyticsParams({
  variant,
  focus,
  animal,
  breedId,
  routeName,
}: {
  variant: 'compact' | 'standard';
  focus: 'buyer' | 'seller';
  animal: 'dog' | 'cat';
  breedId?: number | null;
  routeName?: string | null;
}): AnalyticsEventParams {
  const params: AnalyticsEventParams = {
    widget_type: 'evidensia_booking',
    widget_variant: variant,
    widget_focus: focus,
    animal,
  };
  if (routeName) params.route_name = routeName;
  if (breedId) params.breed_id = breedId;
  return params;
}
